import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.boltin.com';
const LEDGER_API_PATH = '/api/inventory/ledger';

const getLedgerEntries = async (filters = {}) => {
  // The axios interceptor automatically adds the storeId
  const response = await axios.get(`${API_BASE_URL}${LEDGER_API_PATH}`, { params: filters });
  return response.data; // Return the full response with pagination { data: [...], pagination: {...} }
};

const importProducts = async (file, storeId) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('storeId', storeId);

  const response = await axios.post(`${API_BASE_URL}/api/products/import`, formData);
  return response.data;
};

const inventoryLedgerService = {
  getLedgerEntries,
  importProducts,
};

export default inventoryLedgerService;